var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('b-table',_vm._b({attrs:{"outlined":"","thead-tr-class":"staff-table-row","tbody-tr-class":_vm.setTbodyTrClass},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var ref_value = ref.value;
var staff = ref_value.staff;
var name = ref_value.name;
return [_c('b-link',{on:{"click":function($event){return _vm.$emit('select', staff.staffId)}}},[_c('span',{class:("" + (staff.isHiddenInfo == 1 && !_vm.isCompanyShow ? 'txt-line' : ''))},[_vm._v("\n        "+_vm._s(name)+"\n      ")])])]}},{key:"scheduleNotification",fn:function(ref){
var value = ref.value;
return [_c('b-checkbox',{attrs:{"disabled":"","checked":value}})]}},{key:"tel",fn:function(ref){
var ref_value = ref.value;
var staff = ref_value.staff;
var tel = ref_value.tel;
return [_c('span',{class:("" + (staff.isHiddenInfo == 1 && !_vm.isCompanyShow ? 'txt-line' : ''))},[_vm._v("\n      "+_vm._s(tel)+"\n    ")])]}},{key:"mail",fn:function(ref){
var ref_value = ref.value;
var staff = ref_value.staff;
var mail = ref_value.mail;
return [_c('span',{class:("" + (staff.isHiddenInfo == 1 && !_vm.isCompanyShow ? 'txt-line' : ''))},[_vm._v("\n      "+_vm._s(mail)+"\n    ")])]}},{key:"belongsTo",fn:function(ref){
var ref_value = ref.value;
var type = ref_value.type;
var name = ref_value.name;
return [_c('div',[_vm._v(_vm._s(type))]),_c('div',[_vm._v(_vm._s(name))])]}},{key:"invite",fn:function(ref){
var ref_value = ref.value;
var staff = ref_value.staff;
var invitable = ref_value.invitable;
return [_c('div',[(!staff.isHiddenInfo)?[(invitable)?_c('v-invite',{attrs:{"target":staff},on:{"ok":function($event){return _vm.handleInvite(staff.staffId)}}}):_c('small',[_vm._v("登録済")])]:_vm._e()],2)]}}],null,false,4015359369)},'b-table',{ fields: _vm.fields, items: _vm.data },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }